import type { APIFilterState } from '@/_containers';

/** Shared defaults for the main invoice batches table list (standalone + split shell). */
export const invoiceBatchesMainListDefaultApiFilter: Partial<APIFilterState> = {
  per_page: 500,
  sort: '-created_at',
};
